import React from 'react';
import DistanceCenter from './DistanceCenter';
import { centersData } from './centersData';

const AdwaPage = () => {
  const center = centersData[1]; // Access the Adwa data (assuming it's the second entry)
  return <DistanceCenter center={center} />;
};

export default AdwaPage;